import React from 'react'
import { Timeline, Text } from '@workwhile/ui'
import { formatInTimeZone } from 'date-fns-tz'
import { getLocalTimezone } from 'lib/time'
import { toTitleCase } from 'lib/string'

type TimelineRenderProps = {
  statusTransitions: Record<string, string>
}

export const TimelineRender = ({ statusTransitions }: TimelineRenderProps) => {
  const timezone = getLocalTimezone()

  if (!statusTransitions || Object.keys(statusTransitions).length === 0) {
    return <Text>-</Text>
  }

  // Sort transitions by timestamp (most recent first)
  const sortedTransitions = Object.entries(statusTransitions)
    .map(([status, timestamp]) => ({
      status,
      timestamp,
      date: new Date(timestamp),
    }))
    .sort((a, b) => a.date.getTime() - b.date.getTime())

  return (
    <Timeline>
      {sortedTransitions.map(({ status, timestamp }) => {
        const formattedTime = formatInTimeZone(
          timestamp,
          timezone,
          'MMM d, yyyy, h:mm a z'
        )
        const statusLabel = toTitleCase(status.toLowerCase().replace(/_/g, ' '))

        return (
          <Timeline.Item key={`${status}-${timestamp}`}>
            <Text color="lightText" fontSize={0}>
              {formattedTime}
            </Text>
            <Text fontSize={2}>{statusLabel}</Text>
          </Timeline.Item>
        )
      })}
    </Timeline>
  )
}
